import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FormAccessTokenStorageService {
  private static readonly PREFIX = 'form_access_token:';

  private readonly platformId = inject(PLATFORM_ID);
  private readonly storage: Storage;

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.storage = sessionStorage;
    } else {
      this.storage = {
        getItem: () => null,
        setItem: () => {},
        removeItem: () => {},
        clear: () => {},
        length: 0,
        key: () => null,
      };
    }
  }

  get(workspaceSlug: string, formSlug: string): string | null {
    return this.storage.getItem(this.key(workspaceSlug, formSlug));
  }

  set(workspaceSlug: string, formSlug: string, token: string): void {
    this.storage.setItem(this.key(workspaceSlug, formSlug), token);
  }

  clear(workspaceSlug: string, formSlug: string): void {
    this.storage.removeItem(this.key(workspaceSlug, formSlug));
  }

  private key(workspaceSlug: string, formSlug: string): string {
    return `${FormAccessTokenStorageService.PREFIX}${workspaceSlug}/${formSlug}`;
  }
}
